import React from "react";
import styled from "styled-components";
import { AppColors } from "../../config/AppColors";
import { AppFonts } from "../../config/AppFonts";
import AppLoader from "../loader/AppLoader";

const Button = styled.button`
  outline: none;
  border: none;
  height: 3rem;
  font-family: ${AppFonts.regular};
  border-radius: 3.5rem;
  cursor: pointer;
  margin-bottom: 0.75rem;
  width: 100%;

  &:focus {
    outline: none;
    border: none;
  }
`;

function FullButton({ children, onClick, isloading, size, bg, color, margin }) {
  return (
    <Button
      onClick={onClick}
      style={{
        backgroundColor: bg,
        color: color,
        margin: margin,
      }}
    >
      {isloading ? <AppLoader /> : children}
    </Button>
  );
}

export default FullButton;
